module.exports = __webpack_public_path__ + "static/hero-background-9ad0e7509ff98aa37ebab132c39cc0a9.jpg";